import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography, styled } from '@mui/material'
import IconButton from '../IconButton'
import Arrow from '../../eid-icons/Arrow'

const variant = {
    small: '4.4rem',
    medium: '6.4rem',
    large: '8rem',
}

const StyledIconBox = styled(Box)(({ size }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    fontSize: '1.2rem',
    color: '#ffffff',

    width: variant[size],
    height: variant[size],
    backgroundColor: 'rgba(59, 69, 77, 0.75)',
    boxShadow: '0 0.2rem 1.6rem 0 rgba(0, 0, 0, 0.15)',
    borderRadius: '50%',

    '& >svg': {
        color: '#ffffff',
        width: '2rem',
        height: '2rem',
    },
    '&:hover': {
        backgroundColor: 'rgba(59, 69, 77, 0.9)',
        '& >svg': {
            color: '',
        },
    },
}))

const StyledLabel = styled(Typography)({
    fontSize: '1.2rem',
    color: '#ffffff',
    wordBreak: 'break-word',
})

const StyledIconButton = styled(IconButton)({
    padding: 0,
    overflow: 'hidden',
})

const ScrollToTopButton = ({
    onClick,
    label = 'Top',
    size = 'medium',
    ...rest
}) => {
    const { t } = useTranslation()

    return (
        <StyledIconButton
            onClick={onClick}
            size="medium"
            aria-label={t('Common_BackToTop')}
            {...rest}
        >
            <StyledIconBox size={size}>
                <Arrow direction="up" />
                <StyledLabel>{label}</StyledLabel>
            </StyledIconBox>
        </StyledIconButton>
    )
}

export default ScrollToTopButton
